/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OperationLimitNameDTO = {
    OpExecution: 'opExecution',
    OpExecutionSeriesPointFloat: 'opExecutionSeriesPointFloat',
    OpExecutionSeriesPointString: 'opExecutionSeriesPointString',
    OpExecutionSeriesPointOther: 'opExecutionSeriesPointOther',
    ApiCallExecuteOperations: 'apiCallExecuteOperations'
} as const;
export type OperationLimitNameDTO = typeof OperationLimitNameDTO[keyof typeof OperationLimitNameDTO];


export function instanceOfOperationLimitNameDTO(value: any): boolean {
    for (const key in OperationLimitNameDTO) {
        if (Object.prototype.hasOwnProperty.call(OperationLimitNameDTO, key)) {
            if (OperationLimitNameDTO[key as keyof typeof OperationLimitNameDTO] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OperationLimitNameDTOFromJSON(json: any): OperationLimitNameDTO {
    return OperationLimitNameDTOFromJSONTyped(json, false);
}

export function OperationLimitNameDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationLimitNameDTO {
    return json as OperationLimitNameDTO;
}

export function OperationLimitNameDTOToJSON(value?: OperationLimitNameDTO | null): any {
    return value as any;
}

